import { SET_ANALYTICS_DATA } from "../types"

export const setAnalyticsData = (data) => ({
    type: SET_ANALYTICS_DATA,
    payload: data,
})
